import { render, staticRenderFns } from "./Blogs.vue?vue&type=template&id=ec5d62f8&"
import script from "./Blogs.vue?vue&type=script&lang=js&"
export * from "./Blogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports